export const organizationSchema = {

    "@context": "https://schema.org",
    "@type": "Service",
    "url": "https://practido.com",
    "name": "Practido",
    "description": "Practido helps students learn with confidence through daily practice, mock tests, Olympiad preparation, and interactive learning tools. For schools, parents and educators Practido offers AI-powered test creation, chapter-wise question banks, student analytics, and a complete school ERP (attendance, fees, timetable) to streamline admin and boost academic outcomes.",
    "mainEntityOfPage": "https://practido.com",
    "serviceType": [
        "E-learning Online Platform",
        "Maths & Science Practice App",
        "Olympiad Preparation (IMO, NSO, SOF, etc.)",
        "Teacher AI Test Generator",
        "Question Bank Service",
        "Online Mock Tests",
        "School ERP (Attendance, Fees, Timetable, Transport)",
        "Parent & Student Progress Dashboard",
        "Coaching Center Monetization Platform",
        "Marketplace for Paid Courses & Practice Content",
        "AI Assessment & Auto-reporting"
    ],
    "provider": {
        "@type": "Organization",
        "name": "Practido",
        "url": "https://practido.com",
        "logo": "https://practido.com/img/logo.webp",
        "sameAs": [
            "https://www.facebook.com/people/Olympiad-Practice-App/100095416683665/",
            "https://www.linkedin.com/company/practido/",
            "https://x.com/olympiad_p",
            "https://www.instagram.com/practido",
            "https://in.pinterest.com/olympiadpracticeapp/"
        ],
        "contactPoint": [
            {
                "@type": "ContactPoint",
                "telephone": "+91-8448504381",
                "contactType": "customer service",
                "areaServed": "IN",
                "availableLanguage": [
                    "English",
                    "Hindi"
                ]
            }
        ]
    },
    "audience": {
        "@type": "Audience",
        "audienceType": [
            "Schools",
            "Teachers",
            "Parents",
            "Coaching Centers",
            "Students"
        ]
    },
    "areaServed": "IN",
    "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Practido Products",
        "itemListElement": [
            {
                "type": "OfferCatalog",
                "name": "Student & Parent Apps"
            },
            {
                "type": "OfferCatalog",
                "name": "Teacher AI Module"
            },
            {
                "type": "OfferCatalog",
                "name": "Olympiad Practice App"
            },
            {
                "type": "OfferCatalog",
                "name": "School ERP Module"
            },
            {
                "type": "OfferCatalog",
                "name": "Coaching Marketplace"
            }
        ]
    },
    "potentialAction": {
    "@type": "SearchAction",
    "target": "https://practido.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export default organizationSchema;